import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SupportIcon } from './Icons';
import SupportModal from './SupportModal.jsx';

const HelpButton = ({ showTooltip }) => {
  const [supportVisible, setSupportVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (showTooltip) {
      setTooltipVisible(true);
      setIsFadingOut(false);
      const timer = setTimeout(() => {
        setIsFadingOut(true);
        setTimeout(() => {
          setTooltipVisible(false);
          setIsFadingOut(false);
        }, 500); // время анимации fadeOut
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showTooltip]);

  const openSupport = () => setSupportVisible(true);
  const closeSupport = () => setSupportVisible(false);

  return (
    <>
      <ButtonWrapper>
        <Button onClick={openSupport}>
          <SupportIcon/>
        </Button>
        {tooltipVisible && (
          <Tooltip $isFadingOut={isFadingOut}>
             Видеоуроки и операторы поддержки всегда тут
          </Tooltip>
        )}
      </ButtonWrapper>
      {supportVisible && <SupportModal open={supportVisible} onClose={closeSupport} />}
    </>
  );
};

export default HelpButton;

const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 30px;
  left: 8px;
  z-index: 1000;
  padding: 3px;
`

const Button = styled.div`
  position: relative;
  min-width: 60px;
  min-height: 60px;
  border-radius: 18px;
  background-color: #EA394B;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  color: #ffffff !important;
  text-decoration: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
  &:hover {
    transform: scale(1.05);
    color: #ffffff;
    text-decoration: none;
  }
  @media (max-width: 798px) {
    min-width: 45px;
    min-height: 45px;
  }
`

const Tooltip = styled.div`
  position: absolute;
  left: 70px;
  bottom: 50%;
  transform: translateY(50%);
  height: 50px;
  display: flex;
  align-items: center;
  background: rgba(234, 57, 75, 0.8);
  font-weight: bold;
  color: #ffffff;
  padding: 10px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  z-index: 1001;
  animation: ${props => props.$isFadingOut ? 'fadeOut' : 'fadeIn'} 0.5s ease-in-out forwards;

  &::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid rgba(234, 57, 75, 0.8);
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(50%) translateX(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(50%) translateX(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(50%) translateX(0);
    }
    to {
      opacity: 0;
      transform: translateY(50%) translateX(-10px);
    }
  }

  @media (max-width: 798px) {
    font-size: 12px;
    padding: 8px 12px;
    left: 55px;
  }
`
